export default "/images/f70833e21db551350e75e6f54be3d25c.png";